module.exports = __webpack_public_path__ + "img/tuto_mobile_way_02_04.6cc14b96.png";